module.exports = __webpack_public_path__ + "img/safety-management-item1-1.82965895.png";